<div class="generic-modal-root" >

    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
          <h3 style="text-align: center; font-weight: 300;">Submit the ticket's number and reference below</h3>
          
          <input
            [(ngModel)]="ticketNumber"
            style="width: 100%; margin-bottom: 15px;"
            id="referenceNumber"
            type="text"
            [ignoreWhiteSpace]
            class="form-control m-input"
            placeholder="Ticket Number"
          />

          <input
            [(ngModel)]="referenceNumber"
            style="width: 100%;"
            id="referenceNumber"
            type="text"
            [ignoreWhiteSpace]
            class="form-control m-input"
            placeholder="Reference Number"
          />
      </div>
    </div>
  
  
    <div style="height: 45px;">
      <button (click)="close()" class="btn btn-danger" style="margin-left: 15px;float: right;margin-top: 10px;">Cancel</button>
      <button (click)="verify()" class="btn btn-success" style="margin-left: 15px;float: right;margin-top: 10px;">Verify</button>
    </div>
  </div> 